import styled, { css } from 'styled-components'
import { Button, getFontStyle, makeLineClamp } from '@diversioteam/diversio-ds'

export const PanelWrapper = styled.div`
    height: calc(100vh - 73px);
    flex: 0 0 250px;
`

export const Panel = styled.div`
    width: 250px;
    position: fixed;
    top: 73px;
    bottom: 0px;
    left: 70px;
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.primaryGray1};
    border-right: 1px solid ${({ theme }) => theme.colors.primaryWhite};
    box-shadow: 0px 20px 50px 0px rgba(0, 0, 0, 0.08);
    overflow: auto;
`

export const Group = styled.section`
    padding: 20px 24px;
    display: flex;
    flex-direction: column;

    &:last-child {
        margin-top: auto;
        border-top: 1px solid ${({ theme }) => theme.colors.secondary100Transparent};
    }

    &:nth-child(2) {
        overflow: auto;
    }

    &:only-child {
        margin-top: 0;
        border-top: none;
    }
`

export const Title = styled.h3`
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p03Medium')}
`

export const ToggleButton = styled(Button)`
    &.dds-button {
        width: 24px;
        position: absolute;
        right: -12px;
        top: 28px;
        z-index: 1000;
    }
`

export const ListItemWrapper = styled.li<{ focused?: boolean }>`
    display: flex;
    align-items: center;
    margin: 0;
    padding-left: 15px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.colors.secondary100};
    text-decoration: none;
    transition: transform 0.1s cubic-bezier(0.075, 0.82, 0.165, 1);

    ${({ focused }) =>
        focused &&
        css`
            box-shadow: inset 0px 0px 0px 1px ${({ theme }) => theme.colors.primary40};
            border: 1px solid ${({ theme }) => theme.colors.primary40};
            transform: scale(1.02);
        `}

    &:hover {
        border-color: ${({ theme }) => theme.colors.secondary200};
        transform: scale(1.02);
    }
`

export const ListItemLabel = styled.span`
    flex: 1;
    height: 20px;
    color: ${({ theme }) => theme.colors.secondary500};
    cursor: pointer;
    word-break: break-all;

    ${getFontStyle('p02Medium')}

    ${makeLineClamp(1)}
`

export const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
`
